import VueRouter from 'vue-router'
import Vue from 'vue'

import Home from './pages/Home'
import Workout from './pages/Workout'
import WorkoutCustom from './pages/WorkoutCustom'
import WorkoutList from './pages/WorkoutList'
import Video from './pages/Video'
import KitsList from './pages/KitsList'
import Kit from './pages/Kit'

const routes = [
    { path: '/', component: Home },
    { path: '/treino/:id/video/:video', component: Video },
    { path: '/treino/:id/view/:custom', component: WorkoutCustom },
    { path: '/treino/:id', component: Workout },
    { path: '/treino/:id/list', component: WorkoutList },
    { path: '/kits', component: KitsList },
    { path: '/kits/:category/:id', component: Kit },
]

Vue.use(VueRouter)

const router = new VueRouter({
    routes,
})

router.beforeEach( (to, from, next) => {
    window.scrollTo(0, 0)
    next()
})

export default router